// extracted by mini-css-extract-plugin
export default {"BackButton":"BackButton_BackButton__oTN2h","Disabled":"BackButton_Disabled__vKm3w"};